export default "__VITE_ASSET__B0OyS0MY__"